var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useRef } from 'react';
import { generateABTestGroupEntities, generateTracingEntity, generateUserEntity, } from '../tracking-utils/ATCookieEntities.utils';
import { unchangedEntities } from '../tracking-utils/CustomiseEntities.utils';
export var ATConsumerTrackingStateContext = createContext({
    setPageEntity: function () { return null; },
    // TODO: Remove generateUserEntity when migrated - maybe update tests to use @at/test-utils testRender which adds the user context entity.
    withCombinedEntities: function (entities) { return __spreadArray(__spreadArray([], generateUserEntity(), true), entities, true); },
});
ATConsumerTrackingStateContext.displayName = 'ATConsumerTrackingV2_5';
export var ATTracking = function (_a) {
    var addEntities = _a.addEntities, children = _a.children, pageEntity = _a.pageEntity, _b = _a.customiseEntities, customiseEntities = _b === void 0 ? unchangedEntities : _b, _c = _a.skipTracking, skipTracking = _c === void 0 ? false : _c;
    // TODO: Using a ref here so the value is optimistically readable when other functions call withCombinedEntities
    //  outside of any react hook updates. i.e. fire page view events. Could the context pageEntity be used instead
    //  to remove the possibility of state/mutation race-conditions?
    var overriddenPageEntity = useRef(null);
    var setPageEntity = useCallback(function (updatedPageEntity) {
        overriddenPageEntity.current = updatedPageEntity;
    }, [overriddenPageEntity]);
    var withCombinedEntities = useCallback(function (entities) {
        var combinedEntities = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], generateUserEntity(), true), [
            overriddenPageEntity.current !== null ? overriddenPageEntity.current : pageEntity
        ], false), (addEntities !== null && addEntities !== void 0 ? addEntities : []), true), entities, true), generateTracingEntity(), true), generateABTestGroupEntities(), true);
        return customiseEntities(combinedEntities);
    }, [overriddenPageEntity, pageEntity, addEntities, customiseEntities]);
    return (_jsx(ATConsumerTrackingStateContext.Provider, { value: {
            setPageEntity: setPageEntity,
            skipTracking: skipTracking,
            withCombinedEntities: withCombinedEntities,
        }, children: children }));
};
